import store from '@/store';

export default class UserSessionFunctions {
    static setUserSesssionMsisdn(msisdn) {
        sessionStorage.setItem('msisdn', msisdn)
    }

    static setUserSesssionHasLoggedIn(hasLoggedIn) {
        sessionStorage.setItem('hasLoggedIn', hasLoggedIn)
    }

    static getUserSesssionMsisdn() {
       return sessionStorage.getItem('msisdn')
    }

    static getUserSesssionHasLoggedIn() {
       return sessionStorage.getItem('hasLoggedIn')
    }

    static setUserSubscriptions(subscriptions) {
        store.commit('setUserSubscriptions', subscriptions);
    }

    static getUserSubscriptions() {
        const subscriptions = store.state.userSubscriptions;
        return subscriptions !== undefined ? subscriptions : null;
    }
}


